var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { renderChildren } from './utils';
import "./styles.css";
export var Breadcrumbs = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, className = _a.className, props = __rest(_a, ["children", "collapsed", "className"]);
    var _c = useState(collapsed), isCollapsed = _c[0], setCollapsed = _c[1];
    var handleClickAway = function () {
        collapsed && setCollapsed(true);
    };
    var handleClickDots = function () {
        setCollapsed(false);
    };
    var ulRef = useRef(null);
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (ulRef.current &&
                !document.contains.call(ulRef.current, event.target)) {
                handleClickAway();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ulRef]);
    return (React.createElement("nav", __assign({ className: cn('lk-ui_breadcrumbs', className) }, props, { ref: ref }),
        React.createElement("ul", { ref: ulRef, className: 'lk-ui_breadcrumbs-list' }, renderChildren(children, isCollapsed, handleClickDots))));
});
